import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Alert, Button } from 'react-bootstrap';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

import Modal from 'components/Modal';

import RichEditorContent from 'components/RichEditorContent';

class CommunityLeave extends React.Component {
  onSubmit = e => {
    e.preventDefault();

    const {
      doLeave,
      whiteLabel: { id: whiteLabelId },
    } = this.props;

    doLeave(whiteLabelId);
  };

  render() {
    const {
      intl: { messages },
      show,
      close,
      whiteLabel,
      formStatus,
    } = this.props;

    const { community_description: communityDescription } = whiteLabel;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.leave_community}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert bsStyle="info">You are about to leave the community</Alert>
          <RichEditorContent content={'<div>' + communityDescription + '</div>'} />
          <div class="m-t-20">
            <form onSubmit={this.onSubmit} method="post">
              <Button bsStyle="danger" type="submit" bsSize="lg" block disabled={formStatus.pending}>
                <i class={'fa-fw ' + (formStatus.pending ? 'fa fa-circle-notch fa-spin' : 'fal fa-save')} /> Leave
              </Button>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.communityLeave,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doLeave: whiteLabelId => {
      formStatusDispatchHelper(
        'communityLeave',
        `/api/whitelabelcommunities/${whiteLabelId}/leaves.json`,
        {},
        'post',
        dispatch
      );
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CommunityLeave)
);
